export function AvailabilityDot({ status = "available", withLabel = false }) {
  const map = {
    available: { color: "bg-emerald-500", label: "Available" },
    limited: { color: "bg-amber-500", label: "Limited" },
    busy: { color: "bg-red-500", label: "Busy" },
    offline: { color: "bg-slate-400", label: "Offline" },
  };
  const cfg = map[status] || map.offline;
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={`avail-${status}`}>
      <span className={`inline-block w-2 h-2 rounded-full ${cfg.color}`} />
      {withLabel && <span className="text-xs text-muted-foreground">{cfg.label}</span>}
    </span>
  );
}

export function VerifiedBadge({ level = "none", size = "sm" }) {
  if (level === "none") return null;
  const map = {
    community: { label: "Community Verified", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30" },
    experience: { label: "Experience Verified", cls: "bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/30" },
    credential: { label: "Credential Verified", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30" },
    expert: { label: "CLING Expert", cls: "bg-[color:hsl(var(--teal))]/10 text-[color:hsl(var(--teal))] border-[color:hsl(var(--teal))]/40" },
  };
  const cfg = map[level];
  if (!cfg) return null;
  return (
    <span className={`inline-flex items-center gap-1 border rounded-full px-2 py-0.5 text-[10px] font-semibold ${cfg.cls}`}>
      ✓ {cfg.label}
    </span>
  );
}

export function RiskPill({ risk }) {
  const map = {
    routine: { cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30", label: "Routine" },
    caution: { cls: "bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30", label: "Caution" },
    high: { cls: "bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30", label: "High risk" },
    emergency: { cls: "bg-red-600 text-white border-red-800", label: "Emergency — call 911" },
  };
  const cfg = map[risk] || map.routine;
  return <span className={`font-mono-label text-[10px] border rounded-full px-2 py-0.5 ${cfg.cls}`}>{cfg.label}</span>;
}
